var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AssessmentResult } from '../../../shared/models/assessment-result';
import { OnInit, OnDestroy, ElementRef } from '@angular/core';
import { ScaleDataSectionComponent } from 'app/reports/models/scale-list-data-component';
import { ReportNavigatorService } from 'app/reports/services/report-navigator.service';
var TherapistScaleResultsComponent = /** @class */ (function (_super) {
    __extends(TherapistScaleResultsComponent, _super);
    function TherapistScaleResultsComponent(navigator, el) {
        var _this = _super.call(this) || this;
        _this.navigator = navigator;
        _this.el = el;
        _this._skipContent = false;
        _this._skipGraph = false;
        _this._skipTable = false;
        _this._showRangeScore = true;
        _this._rollUpQuestions = false;
        return _this;
    }
    TherapistScaleResultsComponent.prototype.ngOnInit = function () {
        // coming from the decorator.
        // assign all the data that comes from the navigator.
        if (this.externalScalesPerPage) {
            this._scales_per_page = this.externalScalesPerPage;
        }
        if (this.externalScaleResults) {
            (_a = this.ScaleResults).push.apply(_a, this.externalScaleResults);
        }
        if (this.externalAssessmentResult) {
            this.AssessmentResult = this.externalAssessmentResult;
        }
        if (this.externalTitle) {
            this._title = this.externalTitle;
        }
        var _a;
    };
    TherapistScaleResultsComponent.prototype.ngAfterViewInit = function () {
        if (this.ScaleResults) {
            this.populateNavigator(this.ScaleResults);
        }
        _super.prototype.ngAfterViewInit.call(this);
    };
    TherapistScaleResultsComponent.prototype.ngOnDestroy = function () {
        this.cleanupNavigator();
    };
    TherapistScaleResultsComponent.prototype.getLegendLabels = function (scaleResult) {
        return scaleResult.scale.ranges.map(function (r) { return r.displayName; });
    };
    TherapistScaleResultsComponent.prototype.getTitle = function () {
        return this._title;
    };
    TherapistScaleResultsComponent.prototype.setReportData = function (data, results, variables) {
        _super.prototype.setReportData.call(this, data, results, variables);
        if (data && data.hasOwnProperty('expandContent') && data.expandContent === false) {
            this.expandContent = false;
        }
        if (data && data.title) {
            this._title = data.title;
        }
        else {
            this._title = this.Assessment.name;
        }
        if (data && data.scales_per_page) {
            this._scales_per_page = +data.scales_per_page;
        }
        else if (this.ScaleResults) {
            // this makes it so we never force a page break here.
            this._scales_per_page = this.ScaleResults.length + 1;
        }
        else {
            console.error("No scales found for component");
            this._scales_per_page = 0;
        }
        if (data) {
            this._skipTable = data.skipTable == true;
            this._skipGraph = data.skipGraph == true;
            this._skipContent = data.skipContent == true;
            // default is to show them... so we want to check for false instead of true.
            // so that old reports always shows the score range...
            this._showRangeScore = data.showRangeScore !== false;
            this._rollUpQuestions = data.rollUpQuestions == true;
            if (data.hasTableAction) {
                var questionById_1 = this.Assessment.getQuestionsListById();
                this._questionActions = (data.tableActions || []).map(function (ta) {
                    var question = questionById_1[ta.questionId] || {};
                    return {
                        scale: question.scale,
                        question: question,
                        action: ta.action,
                        label: data.tableActionLabel,
                        data: ta.data
                    };
                });
                // this._questionActionsByScale = {};
                // (data.tableActions || []).forEach(ta => {
                //   
                //   let scaleResult = this.ScaleResults.find(sr => sr.scale.id == ta.scaleId);
                //   if (!scaleResult) {
                //     console.error("Could not find scale result with scale id ", ta.scaleId);
                //   } else if (!this._questionActionsByScale[scaleResult.scale.id]) {
                //     this._questionActionsByScale[scaleResult.scale.id] = [];
                //   }
                //   let action = {
                //     scale: scaleResult.scale
                //     ,question: questions[ta.questionId]
                //     ,action: ta.action
                //     ,label: data.tableActionLabel
                //     ,data: ta.data
                //   };
                //   this._questionActionsByScale[ta.scaleId].push(action);
                // })
            }
        }
    };
    TherapistScaleResultsComponent.prototype.shouldShowQuestionList = function (scaleResult) {
        if (this.SkipTable) {
            return false;
        }
        if (this.hasSubScales(scaleResult) && !this.shouldRollUpQuestions(scaleResult)) {
            return false;
        }
        return true;
    };
    TherapistScaleResultsComponent.prototype.shouldRollUpQuestions = function (scaleResult) {
        if (this.RollUpQuestions) {
            return true;
        }
        return scaleResult && scaleResult.scale && scaleResult.scale.rollUpSubScales === true;
    };
    TherapistScaleResultsComponent.prototype.shouldShowSubScalesList = function (scaleResult) {
        if (this.SkipTable) {
            return false;
        }
        if (this.hasSubScales(scaleResult)) {
            if (!this.shouldRollUpQuestions(scaleResult)) {
                return true;
            }
        }
        return false;
    };
    TherapistScaleResultsComponent.prototype.getQuestionsForScaleResult = function (scaleResult, depth) {
        var _this = this;
        if (depth === void 0) { depth = 0; }
        var questionList = [];
        if (depth > 50) {
            console.error("Max recursive depth reached");
            return questionList;
        }
        if (this.hasSubScales(scaleResult)) {
            var subScaleResults = this.getSubScales(scaleResult);
            questionList = subScaleResults.map(function (sr) { return _this.getQuestionsForScaleResult(sr, depth + 1); })
                .reduce(function (prev, curr) { return prev.concat(curr); }, []);
        }
        else {
            questionList = this.Assessment.getQuestionsForScale(scaleResult.scale);
        }
        return questionList;
    };
    TherapistScaleResultsComponent.prototype.getActionByScale = function (scale) {
        return this._questionActions; // for now we just return everything
        // return this._questionActionsByScale[scale.id];
    };
    TherapistScaleResultsComponent.prototype.populateNavigator = function (scaleResults) {
        var _this = this;
        scaleResults.forEach(function (sr) {
            var rootElement = _this.el.nativeElement;
            var element = rootElement.querySelector("#" + _this.getScaleResultNavigatorId(sr));
            if (element) {
                _this.navigator.registerItem(sr.scale.id, element);
            }
        });
    };
    TherapistScaleResultsComponent.prototype.getScaleResultNavigatorId = function (scaleResult) {
        return "id-" + scaleResult.scale.id;
    };
    TherapistScaleResultsComponent.prototype.cleanupNavigator = function () {
        var _this = this;
        this.ScaleResults.forEach(function (sr) {
            _this.navigator.unregisterItem(sr.scale.id);
        });
    };
    TherapistScaleResultsComponent.prototype.shouldPrintBreak = function (index) {
        // since index is 0 based the the user scales per page is 1 based we convert.
        return ((index + 1) % this._scales_per_page == 0);
    };
    TherapistScaleResultsComponent.prototype.shouldReverseScaleGraph = function (scaleResult) {
        return scaleResult && scaleResult.scale && scaleResult.scale.negativeToPositiveRanges;
    };
    Object.defineProperty(TherapistScaleResultsComponent.prototype, "ScalesPerPage", {
        get: function () {
            return this._scales_per_page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TherapistScaleResultsComponent.prototype, "Assessment", {
        get: function () {
            if (this.AssessmentResult) {
                return this.AssessmentResult.assessment;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TherapistScaleResultsComponent.prototype, "SkipContent", {
        get: function () {
            return this._skipContent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TherapistScaleResultsComponent.prototype, "SkipGraph", {
        get: function () {
            return this._skipGraph;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TherapistScaleResultsComponent.prototype, "SkipTable", {
        get: function () {
            return this._skipTable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TherapistScaleResultsComponent.prototype, "ShowRangeScore", {
        get: function () {
            return this._showRangeScore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TherapistScaleResultsComponent.prototype, "RollUpQuestions", {
        get: function () {
            return this._rollUpQuestions;
        },
        enumerable: true,
        configurable: true
    });
    TherapistScaleResultsComponent.prototype.hasSubScales = function (scaleResult) {
        return scaleResult && scaleResult.scale && scaleResult.scale.hasSubScales();
    };
    TherapistScaleResultsComponent.prototype.getSubScales = function (scaleResult) {
        var _this = this;
        if (scaleResult.scale.hasSubScales()) {
            return scaleResult.scale.getSubScaleIds().map(function (si) { return _this.AssessmentResult.getScaleResultByScaleId(si); });
        }
        return [];
    };
    return TherapistScaleResultsComponent;
}(ScaleDataSectionComponent));
export { TherapistScaleResultsComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/therapist-scale-results/therapist-scale-results.component.ts.pre-build-optimizer.js